import { Component, OnInit } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';
import { TokenStore } from '../../services/token.store';

@Component({
  selector: 'boi-unauthorized',
  templateUrl: './unauthorized.page.html'
})
export class UnauthorizedPage implements OnInit {
  public unauthorizedMessage: string;

  constructor(private readonly tokenStore: TokenStore) {}

  public ngOnInit(): void {
    this.unauthorizedMessage =
      this.tokenStore.getSessionToken() && !this.tokenStore.getUserContext().ProfileComplete
        ? ReferenceDataLabels.IncompleteProfile
        : ReferenceDataLabels.NoCaseAccess;
  }
}
